import React, { useMemo } from "react";
import useLanguageChange from "../../hooks/useLanguageChange";
import { closeSilentObserverPopup } from "./SilentObserverUtils";
import { useSelector } from "react-redux";
import { useFlags } from "launchdarkly-react-client-sdk";

const SilentObserverNotificationModal = () => {
    const localisedValues = useLanguageChange();
    const ldFlags = useFlags();
    const { silentUserConnectTheCall } = useSelector((state) => state.silentObserver);
    const isMediateButtonAvailable = useMemo(() => !ldFlags.hideMediateButton, [ldFlags]);

    return (
        <>
            {silentUserConnectTheCall && (
                <div className='notification-message left-notification-message'>
                    <div className='notification-message-box'>
                        <div className='notification-message-text'>
                            <p>
                                {localisedValues?.silent_observer_connect_alert_popup}{" "}
                                {isMediateButtonAvailable && localisedValues?.click_mediate_if_you_would_like_to_join_as_a_participant}
                            </p>
                            <div className='notification-message-dismiss'>
                                <button className='btn text-dec-none' onClick={() => closeSilentObserverPopup(true)}>
                                    <span className='btn-text'>{localisedValues?.dismiss}</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default SilentObserverNotificationModal;
